export default "__VITE_ASSET__CVFO6ztP__"